import { render, staticRenderFns } from "./ModuleBuySell.vue?vue&type=template&id=6589d64e&scoped=true"
import script from "./ModuleBuySell.vue?vue&type=script&lang=js"
export * from "./ModuleBuySell.vue?vue&type=script&lang=js"
import style0 from "./ModuleBuySell.vue?vue&type=style&index=0&id=6589d64e&prod&lang=scss&scoped=true"
import style1 from "./ModuleBuySell.vue?vue&type=style&index=1&id=6589d64e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589d64e",
  null
  
)

export default component.exports